import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useContext, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { BiData } from '@wix/da-bi/pkg/events';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import Add from '@wix/da-ds/pkg/Icons/16x16/Add';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import NativeDropdown from '../../../../../Dropdown/NativeDropdown';
import StandardDropdownMenu from '../../../../../Dropdown/Preset/StandardDropdown/StandardDropdownMenu';
import { PopperDropdownManager, PopperDropdownToggle } from '../../../../../Dropdown/PopperDropdownLayout';
import s from './MoreSuggestionsDropdown.scss';
const MoreSuggestionsDropdown = ({ items, onSelect, commonBiData, buttonClassName })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const logBiEvent = useBiLogger();
    const onDropdownClose = useCallback(()=>{
        logBiEvent(BiData(_object_spread({
            evid: 192,
            is_displayed: 0
        }, commonBiData)));
    }, [
        logBiEvent,
        commonBiData
    ]);
    if (isMobile) {
        return /*#__PURE__*/ React.createElement("div", {
            className: s['root']
        }, /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
            className: cn(buttonClassName, s['more'])
        }, /*#__PURE__*/ React.createElement(Add, {
            size: IconSize.SMALLER,
            disableDefaultColors: true
        })), /*#__PURE__*/ React.createElement(NativeDropdown, {
            className: s['dropdown'],
            items: items,
            onSelect: onSelect
        }));
    }
    return /*#__PURE__*/ React.createElement(PopperDropdownManager, {
        onClose: onDropdownClose
    }, /*#__PURE__*/ React.createElement(PopperDropdownToggle, {
        className: cn(buttonClassName, s['more']),
        "aria-owns": `commentbox-suggestions-menu`,
        "aria-label": t('common.more'),
        onOpenBiData: BiData(_object_spread({
            evid: 192,
            is_displayed: 1
        }, commonBiData)),
        onCloseBiData: BiData(_object_spread({
            evid: 192,
            is_displayed: 0
        }, commonBiData))
    }, /*#__PURE__*/ React.createElement(Add, {
        size: IconSize.SMALLER,
        disableDefaultColors: true
    })), /*#__PURE__*/ React.createElement(StandardDropdownMenu, {
        id: `commentbox-suggestions-menu`,
        items: items,
        role: "menu",
        menuClassName: s['menu'],
        menuScrollable: true,
        onSelect: onSelect
    }));
};
MoreSuggestionsDropdown.displayName = 'MoreSuggestionsDropdown';
export default MoreSuggestionsDropdown;
